import settings from '@/config/settings';

import type {
  IWebhook,
  IWebhookCreate,
  IWebhookUpdate,
} from '@/api/types/webhook';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

import type {IQueryObject} from '@/assets/core/assets/helpers/serialize';

const url = new URL(settings.SERVICES.BACKEND.URL + '/webhook');

export const webhookAPI = useAPIHook<
  IWebhook,
  IWebhook,
  IWebhookCreate,
  IWebhookUpdate,
  IQueryObject
>(url);
